module.exports = __webpack_public_path__ + "static/media/pin_drop_24px_outlined.ae495a6f.svg";